import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ServiceRow, GetServicesResponse } from '../models/servicemanagement.model';

@Injectable({
    providedIn: 'root',
})

export class ServicemanagementService {
    constructor(private http: HttpClient) { }

    // SERVICE MANAGEMENT - GET
    getServices(clientID: number, sortBy?: string, sortDir?: "asc" | "desc", skip = 0, count = 20, searchTerm?: string): Observable<GetServicesResponse> {
        const headers = new HttpHeaders({
        });
        const url = `${environment.apiUrl}service-management/services/${clientID}`;
        const params = new HttpParams()
            .set('sortBy', sortBy ?? '')
            .set('sortDir', sortDir ?? '')
            .set('skip', skip)
            .set('count', count)
            .set('search', searchTerm?.trim() ?? '');

        return this.http.get<GetServicesResponse>(url, { headers: headers, params });
    }

    // SERVICE MANAGEMENT - GET UNASSIGNED SERVICES (for dropdown)
    getUnassignedServices(clientID: number): Observable<ServiceRow[]>{
        const headers = new HttpHeaders({
        });
        const url = `${environment.apiUrl}service-management/services/unassignedServiceCodes/${clientID}`;
        return this.http.get<ServiceRow[]>(url, { headers: headers });
    }

    // SERVICE MANAGEMENT - DELETE
    deleteService(request: { ClientID: number | null | undefined; ServiceName: string | null }): Observable<{ success: boolean }> {
        const headers = new HttpHeaders({
        });
        const url = `${environment.apiUrl}service-management/services`;
        return this.http.request<{ success: boolean }>('DELETE', url, {
            headers: headers,
            body: request,
        });
    }

    // SERVICE MANAGEMENT - ADD
    addService(request: ServiceRow): Observable<{ success: boolean }> {
        const headers = new HttpHeaders({
        });
        const url = `${environment.apiUrl}service-management/services`;
        return this.http.post<{ success: boolean }>(url, request, { headers: headers });
    }
}